<template lang="pug">
  .label-row
    p.label-row__label {{label}}:
    p.label-row__value(:class="{'n-a': hasValue}") {{getLabel}}
</template>

<script>
export default {
  name: 'LabelRow',
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      type: [ Object, Array, String, ],
      default: null,
    },
  },
  computed: {
    label () {
      return this.item.label
    },
    getLabel () {
      return this.value ? this.value : 'not available'
    },
    hasValue () {
      return !this.value
    },
  },
  methods: {
    isEmpty (value) {
      return !value || value === '' || (Array.isArray(value) && value.length === 0)
    },
  },
}
</script>

<style scoped lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .label-row
    &__label
      color $default-color
      font-weight 500

    &__value
      color $default-color-bold-1
      font-weight 500
      white-space pre-line
      &.n-a
        color $default-color-middle !important
        font-style italic
</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/LabelRow.vue